import { Instruction, OpCode, } from '../internal.js';
/**
 * Exec Instruction.
 *
 * Calls a static function. Args are passed to the constructor.
 */
export class ExecInstruction extends Instruction {
    idx;
    exportIdx;
    argsBuf;
    constructor(idx, exportIdx, argsBuf) {
        super(OpCode.EXEC);
        this.idx = idx;
        this.exportIdx = exportIdx;
        this.argsBuf = argsBuf;
    }
}
/**
 * Exec Args Serializer object - implements the Serializable interface.
 */
export const ExecArgsSerializer = {
    read(buf) {
        const idx = buf.readU16();
        const exportIdx = buf.readU16();
        const argsBuf = buf.readFixedBytes(buf.remaining);
        return new ExecInstruction(idx, exportIdx, argsBuf);
    },
    write(buf, instruction) {
        buf.writeU16(instruction.idx);
        buf.writeU16(instruction.exportIdx);
        buf.writeFixedBytes(instruction.argsBuf);
        return buf;
    }
};
